import React from "react";

export interface LoadingScreenProps {
  message?: string;
  className?: string;
}

/** Default full-screen loading state. Replace via `AuthProvider`'s `loadingScreenComponent` prop. */
export function LoadingScreen({ message = "Restoring your session…", className }: LoadingScreenProps) {
  return (
    <div
      className={
        className ??
        "fka-loading flex h-screen w-screen flex-col items-center justify-center gap-4 bg-slate-950 text-slate-300"
      }
      role="status"
      aria-live="polite"
    >
      <div className="fka-spinner h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-amber-500" />
      <p className="fka-loading-message text-sm tracking-wide text-slate-400">{message}</p>
    </div>
  );
}
